/* lemein-gallery-preload.js — 2026-09-03 rewrite.

   WHY: the product page ships 27 images at loading="lazy" (some 1280-1400px wide).
   The five HIDDEN colourway media stay lazy until the moment you pick that colour,
   so the browser only starts downloading the new mockup on the click. That download
   is the lag — not the animation.

   The old version only promoted media that were already SHOWN, and only on
   requestIdleCallback, so the other colourways were never warmed in advance.

   This warms EVERY gallery image, hidden ones included, at window 'load' (after the
   first paint, so it never delays the page) and at low fetch priority so it yields
   to anything the user is actually looking at. */

(function () {
  var warmed = 0;

  function warm() {
    var imgs = document.querySelectorAll(
      '.product-gallery img, .product-gallery__media img, .product-gallery__thumbnail img'
    );

    imgs.forEach(function (img) {
      if (img.dataset.lmWarmed) return;
      img.dataset.lmWarmed = '1';

      /* let the real element fetch normally from now on */
      img.loading = 'eager';

      /* and pull the bytes into cache now, cheaply, honouring srcset/sizes so the
         SAME resolution the layout will ask for is the one we warm */
      var pre = new Image();
      try { pre.fetchPriority = 'low'; } catch (e) {}
      if (img.sizes)  pre.sizes  = img.sizes;
      if (img.srcset) pre.srcset = img.srcset;
      if (img.currentSrc || img.src) pre.src = img.currentSrc || img.src;
      warmed++;
    });

    if (window.__lmWarmLog) console.log('[lemein] warmed', warmed, 'gallery images');
  }

  if (document.readyState === 'complete') warm();
  else window.addEventListener('load', warm, { once: true });

  /* colourway swaps can inject media later; re-warm when the gallery mutates */
  var gallery = document.querySelector('product-gallery, .product-gallery');
  if (gallery && window.MutationObserver) {
    var obs = new MutationObserver(function () { warm(); });
    obs.observe(gallery, { childList: true, subtree: true });
    gallery.__lmWarmObserver = obs;   /* hard ref — otherwise it is garbage collected */
  }
})();
